import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from '@qga/roo-ui/components';
import Currency from 'components/Currency';

const OfferPriceCashAndPoints = ({ totalCash, totalPoints, isClassic = false, marginLeft = 2, collapsedCard = false }) => {
  const { amount: pointsAmount, currency: pointsCurrency } = totalPoints;
  const { amount: cashAmount, currency: cashCurrency } = totalCash;

  return (
    <>
      {isClassic ? (
        <Flex alignItems="center" height="35px">
          <Currency
            amount={pointsAmount}
            currency={pointsCurrency}
            color="greys.charcoal"
            alignCurrency=""
            fontSize={28}
            fontWeight="bold"
            hideCurrency={true}
            roundToCeiling
            currencyTextFontSize={'base'}
            currencyTextSuffix="*"
            data-testid="classic-points-total"
            pl={collapsedCard ? 0 : 2}
          />
          <Text pl={1} pt={1} pb={2} fontWeight={'bold'}>
            {pointsCurrency}
          </Text>
        </Flex>
      ) : (
        <Flex flexDirection="column" alignItems="flex-start" flexWrap="wrap" ml={marginLeft}>
          <Flex alignItems="center" height="35px">
            <Currency
              amount={cashAmount}
              currency={cashCurrency}
              roundToCeiling
              fontSize={28}
              fontWeight="bold"
              hideCurrency={true}
              color="greys.charcoal"
              data-testid="cash-total"
              alignCurrency=""
            />
            <Text pl={1} pt={1} pb={1} fontWeight={'bold'}>
              {cashCurrency}
            </Text>
          </Flex>
          <Text as="div" color="greys.steel" fontSize={16} fontWeight={400} lineHeight={[1.375, 1.5]} textAlign="end">
            or{' '}
            <Currency
              amount={pointsAmount}
              currency={pointsCurrency}
              color="greys.charcoal"
              alignCurrency=""
              fontSize="16px"
              lineHeight="inherit"
              fontWeight="bold"
              roundToCeiling
              currencyTextFontSize="16px"
              currencyTextSuffix="*"
              data-testid="points-total"
            />
          </Text>
        </Flex>
      )}
    </>
  );
};

OfferPriceCashAndPoints.propTypes = {
  totalCash: PropTypes.object.isRequired,
  totalPoints: PropTypes.object.isRequired,
  isClassic: PropTypes.bool,
  marginLeft: PropTypes.number,
  collapsedCard: PropTypes.bool,
};

export default OfferPriceCashAndPoints;
